import React from "react";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import { compose } from "redux";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { withRouter } from "react-router-dom";
import { Link } from "@material-ui/core";
import { Button } from "@material-ui/core";
import { handleLoginSubmit } from '../../redux/modules/auth/actions'
import {Link as RouterLink} from 'react-router-dom'
import { RenderField } from '../../components/RenderField'
import {Card} from '../../components/Card'

const styles = theme => ({
  header: {
    marginBottom: 30
  },
  subheader: {
    marginBottom: 10
  },
  input: {
    marginBottom: 30
  },
});

const validate = values => {
  const errors = {};
  if (values.username !== "test@test.com") {
    errors.username = "Неверный логин";
  }
  if (values.password !== "123123") {
    errors.password = "Неправильный пароль";
  }
  return errors;
};

export const SignupForm = compose(
  withRouter,
  connect(state => ({ loggedIn: state.loggedIn })),
  reduxForm({
    form: "loginForm",
    validate,
    onSubmit: (values, dispatch) => dispatch(handleLoginSubmit())
  }),
  withStyles(styles)
)(({ classes, handleSubmit }) => {
  return (
    <Card>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography
              className={classes.header}
              component="h1"
              variant="h4"
              align="left"
            >
              Регистрация
            </Typography>
            <Typography
              className={classes.subheader}
              component="p"
              align="left"
            >
              Уже зарегистрированы? <Link component={RouterLink} to="/login">Войти</Link>
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Field
              className={classes.input}
              required
              name="email"
              type="email"
              component={RenderField}
              label="Адрес электронной почты"
              color="secondary"
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              className={classes.input}
              required
              name="name"
              type="text"
              component={RenderField}
              label="Имя"
              color="secondary"
              fullWidth
            />
          </Grid>
          <Grid item xs={6}>
            <Field
              className={classes.input}
              required
              name="surname"
              type="text"
              component={RenderField}
              label="Фамилия"
              color="secondary"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <Field
              className={classes.input}
              component={RenderField}
              required
              name="password"
              type="password"
              label="Пароль"
              fullWidth
            />
          </Grid>
          <Grid item xs={12} align="right">
            <Button variant="contained" color="primary" type="submit">
              Войти
            </Button>
          </Grid>
        </Grid>
      </form>
    </Card>
  );
});
